<style scoped src="@/assets/css/styles.css"></style>

<template>
  <v-app>
    <v-app-bar elevation="1" absolute elevate-on-scroll app>
      <v-toolbar-title><img src="/images/berg_logo.png" /></v-toolbar-title>
      <v-spacer></v-spacer>
      <navbar />
    </v-app-bar>

    <!-- Sizes your content based upon application components -->
    <v-main>
      <!-- Provides the application the proper gutter -->
      <v-container fluid>
        <!-- If using vue-router -->
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-footer app class="caption">
      <div class="copyright">{{ new Date().getFullYear() }}. BERG Driver</div>
    </v-footer>
  </v-app>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  components: { Navbar },
  created: function () {
    this.$http.interceptors.response.use(undefined, (err) => {
      return new Promise(() => {
        if (err.response.status === 401) {
          this.$store.dispatch("logout");
          this.$router.push("/login");
        }
        throw err;
      });
    });
  },
};
</script>
